module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('el-col', {
    staticClass: "logo logo-width",
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n    " + _vm._s(_vm.sysName) + "\n  ")]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 10
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [(_vm.account.avatarLink) ? _c('img', {
    attrs: {
      "src": _vm.account.avatarLink
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.account.name))]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.logout($event)
      }
    }
  }, [_vm._v("Logout")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f18abd"}!./src/components/navbar/navbar.html
// module id = 813
// module chunks = 1